import { FC } from "react";
import { useNavigate } from "react-router";
import NotFoundFallback from "@/components/NotFoundFallback";

const NotFoundPage: FC = () => {
  const navigate = useNavigate();
  return <NotFoundFallback onGoHome={() => navigate("/")} />;
};

export default NotFoundPage;
